import $ from 'jquery';
import 'slick-carousel/slick/slick.js'; 
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../../css/related-carousel.css';

export function initRelatedCarousel() {
  const $carousel = $('.related-products-carousel');

  if (!$carousel.length) {
    console.warn('⚠️ .related-products-carousel not found');
    return;
  }

  console.log('🌀 Initializing Related Products Slick Carousel...');

  // Check that .slick exists before calling it
  if (typeof $carousel.slick !== 'function') {
    console.error('❌ Slick is not a function. Check if jQuery or Slick failed to load.');
    return;
  }

  $carousel.slick({
    slide: '.woocommerce-product-item',
    slidesToShow: 3,
    slidesToScroll: 3,
    rows: 0,
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    prevArrow: '<button type="button" class="slick-prev"><span class="arrow-icon">&#10094;</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span class="arrow-icon">&#10095;</span></button>',
    accessibility: true,
    focusOnSelect: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 }
      }
    ]
  });
}